import { render, staticRenderFns } from "./ExamStatus.vue?vue&type=template&id=18541814&scoped=true"
import script from "./ExamStatus.vue?vue&type=script&lang=js"
export * from "./ExamStatus.vue?vue&type=script&lang=js"
import style0 from "./ExamStatus.vue?vue&type=style&index=0&id=18541814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18541814",
  null
  
)

export default component.exports